import { MaalerType, opretTomMaalerType } from "./maaler-type.model";
import { Maaler, opretTomMaaler } from "./maaler.model";

export class MaalerOplysninger extends Maaler {
    public maalerType: MaalerType;
}

export function opretTomMaalerOplysninger(): MaalerOplysninger {
    const maaler = opretTomMaaler();
    const maalerType = opretTomMaalerType();
    return { ...maaler, maalerType };
}
